import { ca } from '@cian/analytics';

export function trackOnModalClose() {
  ca('eventSite', {
    name: 'oldevent',
    category: 'Profile_user_comm_popup',
    action: 'Click',
    label: 'Close',
  });
}
